import moment from "moment";
import { toast, ToastOptions } from "react-toastify";

const alertOpts = {
  theme: "light",
  position: toast.POSITION.TOP_RIGHT,
} as ToastOptions;

const showToast = (content: any, type?: string) => {
  toast.dismiss();
  switch (type) {
    case "warn":
      toast.warn(content, alertOpts);
      break;
    case "info":
      toast.info(content, alertOpts);
      break;
    case "success":
      toast.success(content, alertOpts);
      break;
    case "error":
      toast.error(content, alertOpts);
      break;
    default:
      toast(content, alertOpts);
  }
};

export const ShowAlert = {
  Default: (content: any) => showToast(content),
  Warning: (content: any) => showToast(content, "warn"),
  Info: (content: any) => showToast(content, "info"),
  Success: (content: any) => showToast(content, "success"),
  Error: (content: any) => showToast(content, "error"),
};

export const formatter = (price: any) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(price);

export const formatDate = (input: any, format: string = "DD/MM/YYYY hh:MM") =>
  input ? moment(input).format(format) : null;
